import { useQuery } from '@tanstack/react-query';
import api from '../lib/axios';

// System-Health (alle Projekte) — nicht projektgebunden.
export function useAgentHealth() {
  return useQuery({
    queryKey: ['agent-health'],
    refetchInterval: 60000,
    queryFn: async () => (await api.get('/agent-health', { skipProject: true })).data,
  });
}
